import { useState } from 'react';
import { useDroits } from '../auth';
import { useApi } from '../hooks';
import { Chargement, MessageErreur, Pagination, Statut, StatutLicence, formatDate } from '../components/ui';
import { AjoutPoste } from './ClientDetail';
import { FichePoste } from './PosteDetail';

export default function Postes() {
  const { support } = useDroits();
  const [q, setQ] = useState('');
  const [clientId, setClientId] = useState('');
  const [softwareId, setSoftwareId] = useState('');
  const [conventionne, setConventionne] = useState('');
  const [status, setStatus] = useState('');
  const [page, setPage] = useState(1);
  const { donnees: logiciels } = useApi('/logiciels');
  const { donnees: clients } = useApi('/clients/noms');
  const [ficheId, setFicheId] = useState(null);
  const [creation, setCreation] = useState(false);
  const { donnees, erreur, chargement, recharger } = useApi('/postes', { q, clientId, softwareId, conventionne, status, page });

  const filtrer = (fn) => (e) => {
    fn(e.target.value);
    setPage(1);
  };

  return (
    <>
      <div className="titre-page">
        <h1>Postes</h1>
        {support && (
          <button className="btn btn-principal" onClick={() => setCreation(true)}>
            + Nouveau poste
          </button>
        )}
      </div>
      <div className="barre-filtres">
        <input type="search" placeholder="Rechercher (poste, licence, client, nom machine)" value={q} onChange={filtrer(setQ)} />
        <select value={clientId} onChange={filtrer(setClientId)}>
          <option value="">Tous les clients</option>
          {clients?.map((c) => (
            <option key={c.id} value={c.id}>
              {c.name}
            </option>
          ))}
        </select>
        <select value={softwareId} onChange={filtrer(setSoftwareId)}>
          <option value="">Tous les logiciels</option>
          {logiciels?.map((l) => (
            <option key={l.id} value={l.id}>
              {l.name}
            </option>
          ))}
        </select>
        <select value={conventionne} onChange={filtrer(setConventionne)}>
          <option value="">Toutes les conventions</option>
          <option value="oui">Conventionnés</option>
          <option value="non">Non conventionnés</option>
        </select>
        <select value={status} onChange={filtrer(setStatus)}>
          <option value="">Tous les statuts</option>
          <option value="ACTIVE">Actifs</option>
          <option value="INACTIVE">Inactifs</option>
        </select>
      </div>

      <MessageErreur erreur={erreur} />
      {chargement && !donnees ? (
        <Chargement />
      ) : (
        donnees && (
          <div className="carte">
            <table>
              <thead>
                <tr>
                  <th>Client</th>
                  <th>Poste</th>
                  <th>Licence</th>
                  <th>Logiciels</th>
                  <th>Machine</th>
                  <th>Dernière connexion</th>
                  <th>Mise à jour</th>
                  <th>Convention</th>
                  <th>Statut</th>
                </tr>
              </thead>
              <tbody>
                {donnees.donnees.map((p) => (
                  <tr key={p.id} className="ligne-cliquable" onClick={() => setFicheId(p.id)}>
                    <td>{p.client.name}</td>
                    <td>
                      <span className="lien">{p.name}</span>
                    </td>
                    <td>
                      {p.license.licenseKey} <StatutLicence active={p.licenceActive} actives={p.licencesActives} total={p.nombreLogiciels} />
                    </td>
                    <td>{p.logiciels.map((l) => l.name).join(', ') || '—'}</td>
                    <td>{p.hostname || '—'}</td>
                    <td>{formatDate(p.lastConnectionAt, true)}</td>
                    <td>
                      <Statut valeur={p.etatMiseAJour} />
                    </td>
                    <td>{p.client.conventionne ? 'Conventionné' : 'Non conventionné'}</td>
                    <td>
                      <Statut valeur={p.status} />
                    </td>
                  </tr>
                ))}
                {donnees.donnees.length === 0 && (
                  <tr>
                    <td colSpan={9} className="muted">
                      Aucun poste.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <Pagination pagination={donnees.pagination} onPage={setPage} />
          </div>
        )
      )}

      {creation && (
        <AjoutPoste
          onFermer={() => setCreation(false)}
          onAjoute={(poste) => {
            setCreation(false);
            recharger();
            setFicheId(poste.id);
          }}
        />
      )}
      {ficheId && (
        <FichePoste
          id={ficheId}
          onFermer={() => {
            setFicheId(null);
            recharger();
          }}
        />
      )}
    </>
  );
}
